import { addDays, differenceInCalendarDays, endOfWeek } from 'date-fns';
export function getOutsideEndDays(month, options) {
    var days = [];
    var lastDayOfWeek = endOfWeek(month, options);
    var endDiff = differenceInCalendarDays(lastDayOfWeek, month);
    for (var i = 1; i <= endDiff; i++) {
        var dayDate = addDays(month, i);
        days.push(dayDate);
    }
    return days;
}
//# sourceMappingURL=getOutsideEndDays.js.map